import DigitalLendingPortalEnvironment from 'enums/asd';

export default class EnvironmentApi {
  public async getEnvironment(): Promise<DigitalLendingPortalEnvironment> {
    const response = await fetch('/api/environment');

    return response.text() as unknown as DigitalLendingPortalEnvironment;
  }
}
